import { useQuery } from "@tanstack/react-query";
import { Typography } from "antd";
import { journalsQueries } from "@/entities/journal";
import { TableInfo, TableInfoType } from "@/features/table-info";
import { useCoordinator } from "@/shared/lib/hooks";
import { fallbackString } from "@/shared/utils";

interface IJournalsStateSupervision {
  // TODO надо бы убрать any
  titleData: any;
}

export const JournalsStateSupervision = ({
  titleData,
}: IJournalsStateSupervision) => {
  const { titleId } = useCoordinator();
  const { data: journalDetailsData, isPending: isJournalDetailsLoading } =
    useQuery(
      journalsQueries.getTitleDetails({
        mainJournalId: titleData?.mainJournal?.mainJournalId || "",
        registrationInfoId:
          titleData?.mainJournal?.titleJournal?.registrationInfoId || "",
        titleId,
      }),
    );
  const info =
    journalDetailsData?.buildingInfo?.supervisionInfo?.supervisoryAuthorityInfo;
  const tableData: TableInfoType[] = [
    {
      id: 1,
      title: "Наименование",
      info: fallbackString(info?.name),
    },
    {
      id: 2,
      title: "ИНН",
      info: fallbackString(info?.inn),
    },
    {
      id: 3,
      title: "ОГРН",
      info: fallbackString(info?.ogrn),
    },
    {
      id: 4,
      title: "Адрес",
      info: fallbackString(info?.address?.stringAddress),
    },
    {
      id: 5,
      title: "Телефон",
      info: fallbackString(info?.contactInfo?.phone),
    },
    {
      id: 6,
      title: "E-mail",
      info: fallbackString(info?.contactInfo?.email),
    },
  ];

  if (!info) {
    return (
      <div className="table-container">
        <Typography.Title level={4}>
          Сведения об органе государственного строительного надзора
        </Typography.Title>
        <div className="journal-empty-text">
          Сведения не присланы
        </div>
      </div>
    );
  }

  return (
    <TableInfo
      tabs={tableData}
      name="Сведения об органе государственного строительного надзора"
      id="journals-state-supervision"
      isLoading={isJournalDetailsLoading}
    />
  );
};
